{
  "title": "Illusory Script",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level illusion (ritual)",
  "level": 1,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "S, M (a lead-based ink worth at least 10 gp, which the spell consumes)",
  "duration": "10 days",
  "description": [
    "You write on parchment, paper, or some other suitable writing material and imbue it with a potent illusion that lasts for the duration.",
    "To you and any creatures you designate when you cast the spell, the writing appears normal, written in your hand, and conveys whatever meaning you intended when you wrote the text. To all others, the writing appears as if it were written in an unknown or magical script that is unintelligible. Alternatively, you can cause the writing to appear to be an entirely different message, written in a different hand and language, though the language must be one you know.",
    "Should the spell be dispelled, the original script and the illusion both disappear. A creature with truesight can read the hidden message."
  ],
  "spellLists": ["bard", "arcane-trickster", "warlock", "wizard"]
}
